<template>
  <CygnusIcon
    :name="tick ? 'check-circle' : 'x-circle'"
    variant="solid"
    :class="tick ? 'tick-or-cross--tick' : 'tick-or-cross--cross'"
  />
</template>

<script setup>
import CygnusIcon from '@apexl/icarus-core/src/components/icons/CygnusIcon.vue';

const props = defineProps(
    {
      tick: {
        type: Boolean,
        required: true
      }
    }
)
</script>

<style>
.tick-or-cross--tick {
  color: green;
}

.tick-or-cross--cross {
  color: red;
}
</style>
